import {
	LOAD_PRIORITIES_SUCCESS,
	type LoadPrioritiesSuccessAction,
} from '../../../actions/priorities';
import type { PrioritiesEntityState } from './types';

type Action = LoadPrioritiesSuccessAction;

const defaultState: PrioritiesEntityState = [];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: PrioritiesEntityState = defaultState,
	action: Action,
): PrioritiesEntityState => {
	switch (action.type) {
		case LOAD_PRIORITIES_SUCCESS: {
			return action.payload;
		}
		default:
			return state;
	}
};
